const BREAKPOINTS = {
  smallMobile: 374,
  mobile: 576,
  tablet: 780,
  desktop: 1080,
  desktopLarge: 1281,
};

export default BREAKPOINTS;
